<template>
  <PauseFlowCPCModal
    v-if="currentCampaignType === 'cpc'"
    :isOpen="isOpen"
    @toggleChangeCampaignModal="emit('toggleChangeCampaignModal', $event)"
  />

  <PauseFlowCPAModal v-else :isOpen="isOpen" @toggleChangeCampaignModal="emit('toggleChangeCampaignModal', $event)" />
</template>

<script setup>
import { useCampaign } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'
import PauseFlowCPCModal from '@/components/rateConnect/pauseFlow/cpc/PauseFlowCPCModal.vue'
import PauseFlowCPAModal from '@/components/rateConnect/pauseFlow/cpa/PauseFlowCPAModal.vue'

defineProps({
  isOpen: Boolean,
})

const emit = defineEmits(['toggleChangeCampaignModal'])

const { currentCampaignType } = useCampaign(selectedAccommodationId)
</script>
